<template>
  <div class="content" v-loading="loading">
    <el-table :data="tableData" style="width: 100%;margin-top:0;">
      <el-table-column
        prop="number"
        label="设备号"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column label="发送状态" align="center">
        <template slot-scope="scope"
          ><span :style="{ color: sendArrColor[scope.row.is_send] }">{{
            sendArr[scope.row.is_send]
          }}</span>
          </template>
      </el-table-column>

      <el-table-column prop="content" label="发送内容"></el-table-column>
      <el-table-column label="设置状态" align="center">
        <template slot-scope="scope"
          ><span :style="{ color: sendArrColor[scope.row.is_success] }">{{
            setArr[scope.row.is_success]
          }}</span>
          </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
  </div>
</template>
<script>
import lightGroupApi from "@/api/light/lampGroup";
export default {
  name: "deviceList",
  props: {
    groupId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      sub_dialogVisible: false,
      setArr:['设置失败','设置成功'],
      sendArr:['发送失败','发送成功'],
      sendArrColor: ["#F56C6C", "#67C23A"],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 40
      },
      cnt_all: 0
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取该设备所选媒体文件列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      lightGroupApi.virtualMulticastLogList(this.groupId,this.pageInfo).then((res) => {
        console.log('virtualMulticastLogList',res)
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.content {
  width: 100%;
}
</style>
